module.exports = __webpack_public_path__ + "static/img/djkx1.32b3ce5.jpeg";


//////////////////
// WEBPACK FOOTER
// ./static/djkx1.jpeg
// module id = VpPY
// module chunks = 1